<template>
  <Admin style="background: #f2f2f2">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-screen">
          <v-card-text>
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <div
              class="tw-mx-5 tw-font-bold tw-text-xl tw-text-black tw-tracking-wide d-flex justify-space-between mb-6"
            >
              <span>ช่อมอัตราแลกเปลี่ยน</span>
            </div>
            <div class="tw-flex tw-mx-5 tw-space-x-8">
              <div class=" 2xl:tw-w-1/5 tw-w-2/5">
                <p class="tw-text-lg">เลือกวันที่</p>
                <v-date-picker
                  color="primary"
                  v-model="selectedDate"
                  class="tw-w-full"
                ></v-date-picker>
                <p class="tw-text-lg tw-mt-4">เลือกธนาคาร</p>
                <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                  v-model="selectedBank"
                  :items="bankList"
                  item-value="name"
                  item-text="name"
                  item-disabled="disabled"
                  placeholder="-- กรุณาเลือกธนาคาร"
                  class=" p-0 m-0"
                  outlined
                  dense
                >
                  <template v-slot:item="{ item }">
                    <div
                      :class="`d-flex align-center p-0 m-0 ${
                        item.disabled && 'tw-opacity-60'
                      }`"
                    >
                      <v-img
                        :src="item.image"
                        max-width="24"
                        class="mr-3 tw-rounded-full"
                      />
                      <span>{{ item.name }}</span>
                    </div>
                  </template>

                  <template v-slot:selection="{ item }">
                    <div class="d-flex align-center">
                      <v-img
                        :src="item.image"
                        max-width="24"
                        class="mr-3 tw-rounded-full"
                      />
                      <span class="tw-truncate tw-w-52">{{ item.name }}</span>
                    </div>
                  </template>
                </v-select>
                <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                  <v-btn
                    color="blue"
                    :disabled="isFetching || !selectedBank"
                    @click="fetchExchangeRate()"
                    class="tw-text-white tw-mb-4"
                  >
                    <v-icon class="mr-1">mdi-cloud-sync</v-icon
                    >{{ isFetching ? "กำลังดึงข้อมูล..." : "ดึงข้อมูล" }}</v-btn
                  >
                  <v-btn
                    color="red"
                    outlined
                    :disabled="isFetching || !selectedBankRates"
                    @click="clearBankRates()"
                  >
                    <v-icon>mdi-trash-can</v-icon>
                    ล้างข้อมูล
                  </v-btn>
                </div>
                <v-btn
                  :disabled="isFetching || !selectedBankRates"
                  color="primary"
                  class="tw-w-full"
                  outlined
                >
                  <v-icon class="mr-1">mdi-content-save</v-icon
                  >บันทึกลงฐานข้อมูล</v-btn
                >
              </div>


              
              <div class="tw-flex-1 tw-flex tw-flex-col">
                <p class="tw-text-lg">
                  ดึงข้อมูลวันที่ <b>{{ selectedBankRates?.date || "-" }}</b>
                </p>
                <div class="tw-rounded-lg tw-flex-1 tw-h-full">
                  <v-data-table
                    :headers="tableHeaders"
                    :items="exchangeRates"
                    class="elevation-2 tw-rounded-lgl"
                    :items-per-page="-1"
                    item-value="currencyCode"
                  >
                    <template v-slot:item.buyingNotes="{ item }">
                      <span>{{ item.buyingNotes }}</span>
                    </template>
                    <template v-slot:item.buyingCHQ="{ item }">
                      <span>{{ item.buyingCHQ || '-' }}</span>
                    </template>
                    <template v-slot:item.buyingEXP="{ item }">
                      <span>{{ item.buyingEXP }}</span>
                    </template>
                    <template v-slot:item.buyingTRN="{ item }">
                      <span>{{ item.buyingTRN }}</span>
                    </template>
                    <template v-slot:item.sellingNotes="{ item }">
                      <span>{{ item.sellingNotes }}</span>
                    </template>
                    <template v-slot:item.sellingCHQ="{ item }">
                      <span>{{ item.sellingCHQ || '-' }}</span>
                    </template>
                    <template v-slot:item.currencyPer="{ item }">
                      <span>{{ item.currencyPer }}</span>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import { mapState } from "vuex";
import fc from "@/firebaseConfig";
import firebase from "firebase";
import axios from "axios";
import moment from "moment";

export default {
  name: "Settings",
  components: {
    Admin,
  },
  computed: mapState({
    selectedCompany: (state) => state.companies.selectedCompany,
  }),
  mounted() {
    this.selectedDate = new Date().toISOString().substr(0, 10);
  },
  data: () => ({
    items: [
      {
        text: "ตั้งค่า",
        disabled: false,
        to: { name: "Company.Settings" },
      },
      {
        text: "ช่อมอัตราแลกเปลี่ยน",
        disabled: true,
      },
    ],
    bankList: [
      {
        name: "BOT - Bank of Thailand",
        image: "/images/banks-small/bot.png",
        apiUrl: fc.cloudFunctionUrl + "",
        bankCode: "BOT",
        disabled: true,
      },
      {
        name: "KBANK - KasikornBank",
        image: "/images/banks-small/kbank.png",
        apiUrl: fc.cloudFunctionUrl + "apiGetFxKBANK",
        bankCode: "KBANK",
        disabled: true,
      },
      {
        name: "SCB - Siam Commercial Bank",
        image: "/images/banks-small/scb.png",
        apiUrl: fc.cloudFunctionUrl + "",
        disabled: true,
      },
      {
        name: "KTB - Krung Thai Bank",
        image: "/images/banks-small/ktb.png",
        apiUrl: fc.cloudFunctionUrl + "",
        bankCode: "KTB",
        disabled: true,
      },
      {
        name: "BBL - Bangkok Bank",
        image: "/images/banks-small/bbl.png",
        apiUrl: fc.cloudFunctionUrl + "",
        disabled: true,
        bankCode: "BBL",
      },
      {
        name: "BCEL - Banque Pour Le Commerce Exterieur Lao Public",
        image: "/images/banks-small/bcel.png",
        apiUrl: fc.cloudFunctionUrl + "apiGetFxBCEL",
        disabled: false,
        bankCode: "BCEL",
      },
      {
        name: "UOB - United Overseas Bank",
        image: "/images/banks-small/uob.png",
        apiUrl: fc.cloudFunctionUrl + "",
        bankCode: "UOB",
        disabled: true,
      },
    ],
    selectedBank: "",
    selectedBankAPI: "",
    selectedDate: "",
    selectedBankRates: "",
    isFetching: false,
    tableHeaders: [
      { text: "Currency Code", value: "currencyCode" },
      { text: "Currency Name", value: "currencyName" },
      { text: "Buying Notes", value: "buyingNotes" },
      { text: "Buying CHQ", value: "buyingCHQ" },
      { text: "Buying EXP", value: "buyingEXP" },
      { text: "Buying TRN", value: "buyingTRN" },
      { text: "Selling Notes", value: "sellingNotes" },
      { text: "Selling CHQ", value: "sellingCHQ" },
      { text: "Currency Per", value: "currencyPer" },
    ],
    exchangeRates: [],
  }),
  methods: {
    clearBankRates() {
      this.selectedBankRates = "";
      this.exchangeRates = [];
    },
    async fetchExchangeRate() {
      this.selectedBankRates = "";
      this.exchangeRates = [];
      this.isFetching = true;

      let token = await firebase.auth().currentUser.getIdToken(false);
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };

      const formatDateYYYYMMDD = moment(this.selectedDate).format("YYYY-MM-DD");

      const body = {
        date: formatDateYYYYMMDD,
      };

      const apiUrl = this.selectedBankAPI || "http://127.0.0.1:5001/sld-etax/us-central1/apiGetFxBCEL";

      await axios
        .post(apiUrl, body, { headers })
        .then((response) => {
          if (response.status === 200) {
            this.selectedBankRates = response.data;
            this.processExchangeRates(response.data.rates);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      this.isFetching = false;
    },
    processExchangeRates(rates) {
      this.exchangeRates = Object.keys(rates).map((key) => ({
        currencyCode: key,
        currencyName: rates[key].CurrencyName,
        buyingNotes: rates[key].BuyingNotes,
        buyingCHQ: rates[key].BuyingCHQ,
        buyingEXP: rates[key].BuyingEXP,
        buyingTRN: rates[key].BuyingTRN,
        sellingNotes: rates[key].SellingNotes,
        sellingCHQ: rates[key].SellingCHQ,
        currencyPer: rates[key].CurrencyPer,
      }));
    },
  },
  watch: {
    selectedBank: {
      handler: function () {
        const bankCode = this.selectedBank.split("-")?.[0]?.trim();
        this.selectedBankAPI = this.bankList.find(
          (bank) => bank.bankCode === bankCode
        )?.apiUrl || "";
      },
    },
  },
};
</script>
